export class ReferenceData {
    public id: number;
    public name: string;
    public filterDescription: string;
    public value: any;

    constructor(id: number, name: string, description: string, value: any) {
        this.id = id;
        this.name = name;
        this.filterDescription = description;
        this.value = value;
    }
}

export class BreachType {
  public static TradingHours = new ReferenceData(1, "Trading Hours", "Show Trading Hours only", "Trading Hours");
  public static ShutdownHours = new ReferenceData(2, "Shutdown Hours", "Show Shutdown Hours only", "Shutdown Hours");
  public static CancelledLicence = new ReferenceData(3, "Cancelled Licence", "Show Cancelled Licence only", "Cancelled Licence");

  public static GetAll(): Array<ReferenceData> {
      return [this.TradingHours, this.ShutdownHours, this.CancelledLicence];
  }
}

export class LicenceType {
  public static Hotel = new ReferenceData(1, "Hotels", "Hotels", "Hotel");
  public static Club = new ReferenceData(2, "Clubs", "Clubs", "Club");

  public static GetAll(): Array<ReferenceData> {
      return [this.Hotel, this.Club];
  }
}

export class MonitoringSystem {
    public static MAXsys = new ReferenceData(1, "MAXsys", "Show MAXsys premises only", "MAXsys");
    public static CMS = new ReferenceData(2, "CMS", "Show CMS premises only", "CMS");

    public static GetAll(): Array<ReferenceData> {
        return [this.MAXsys, this.CMS];
    }
}

export class DatePeriod {
    public static LastHour = new ReferenceData(1, "LastHour", "Last hour", 1);
    public static Last24Hours = new ReferenceData(2, "Last24Hours", "Last 24 hours", 24);
    public static Last2Days = new ReferenceData(3, "Last2Days", "Last 2 days", 48);
    public static Last7Days = new ReferenceData(4, "Last7Days", "Last 7 days", 168);
    public static Last30Days = new ReferenceData(5, "Last30Days", "Last 30 days", 720);

    public static GetAll(): Array<ReferenceData> {
        return [this.LastHour, this.Last24Hours, this.Last2Days, this.Last7Days, this.Last30Days];
    }
}



// WEBPACK FOOTER //
// ./client/app/models/reference-data-model.ts